import { createStore } from "zustand/vanilla";
import { IconProps } from "@iconify/react";
import { ReactNode } from "react";

export type ToastProps = {
  id?: string;
  message: ReactNode;
  icon?: IconProps["icon"];
  color: "success" | "destructive" | "warning" | "info";
  timestamp?: number;
};

export type ToastState = {
  toastQueue: ToastProps[];
};

export type ToastActions = {
  addToastToQueue: (toast: ToastProps) => void;
  removeToastFromQueue: (id: string) => void;
};

export type ToastStore = ToastActions & ToastState;

export const defaultInitState: ToastState = {
  toastQueue: [],
};

export const createToastStore = (initState: ToastState = defaultInitState) => {
  return createStore<ToastStore>()((set) => ({
    ...initState,
    addToastToQueue: (toast) => {
      set((state) => ({
        toastQueue: [
          ...state.toastQueue,
          {
            ...toast,
            id: toast?.id || Date.now().toString(),
            timestamp: Date.now(),
          },
        ],
      }));
    },
    removeToastFromQueue: (id) => {
      set((state) => {
        const newQueue = [...state.toastQueue];
        const index = newQueue.findIndex((toast) => toast.id === id);
        newQueue.splice(index, 1);
        return {
          toastQueue: newQueue,
        };
      });
    },
  }));
};
